import React from "react";
import { Link, Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { getMerchantPortalAdminToken, setMerchantPortalAdminToken } from "../../services/api";
import { LanguagePicker } from "../../components/LanguagePicker";
import { t } from "../../i18n";

export default function AdminLayout() {
  const navigate = useNavigate();
  const token = getMerchantPortalAdminToken();

  function logout() {
    setMerchantPortalAdminToken(null);
    navigate("/admin/login", { replace: true });
  }

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="app-layout">
      <aside className="sidebar" style={{ width: 220 }}>
        <div className="sidebar__header">
          <span className="sidebar__logo">{t("admin.brand")}</span>
        </div>
        <nav className="sidebar__nav">
          <NavLink
            to="/admin/merchants"
            className={({ isActive }) => `sidebar__link ${isActive ? "sidebar__link--active" : ""}`}
          >
            <span className="sidebar__link-text">{t("admin.nav.merchants")}</span>
          </NavLink>
          <NavLink
            to="/admin/partners"
            className={({ isActive }) => `sidebar__link ${isActive ? "sidebar__link--active" : ""}`}
          >
            <span className="sidebar__link-text">{t("admin.nav.partners")}</span>
          </NavLink>
        </nav>
        <div
          style={{
            marginTop: "auto",
            padding: "12px 16px",
            borderTop: "1px solid var(--border-color)",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <Link
            to="/login"
            style={{ fontSize: 12, color: "var(--text-secondary)", textDecoration: "underline" }}
          >
            {t("auth.portal")}
          </Link>
          <LanguagePicker style={{ fontSize: 12 }} />
          <button
            type="button"
            onClick={logout}
            style={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: 10,
              border: "1px solid var(--border-color)",
              background: "var(--primary-light)",
              color: "var(--text-secondary)",
              cursor: "pointer",
              fontSize: 13,
            }}
          >
            {t("admin.log_out")}
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
